import { render, staticRenderFns } from "./WorkflowPrepTaskServerTable.vue?vue&type=template&id=5b3e132a"
import script from "./WorkflowPrepTaskServerTable.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepTaskServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports